import { Component, Input } from '@angular/core';
import { NavController } from '@ionic/angular';

import { BonesMenuCardAction } from '../../model/bones-menu-card-action';

/**
 * Display a series of cards of menu items.
 * 
 * Actions is a list of BonesMenuCardAction objects.
 * 
 * @example
 * <bones-card-menu [actions]="actions"></bones-card-menu>
 */
@Component({
  selector: 'bones-card-menu',
  templateUrl: 'bones-card-menu.html',
  styleUrls: [ 'bones-card-menu.scss' ]
})
export class BonesCardMenuComponent
{
    /**
     * Array of BonesMenuCardAction objects.
     */
    @Input() actions: BonesMenuCardAction[];

    /**
     * @ignore
     */
    constructor(
        private navCtrl: NavController
    )
    {
    }

    /**
     * Execute menu item.
     * 
     * @param action Action to execute.
     */
    do(action: BonesMenuCardAction)
    {
        if (typeof action.action === 'string')
        {
            this.navCtrl.navigateForward(action.action);
        }
        else
        {
            action.action(action.args);
        }
    }

}
